var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10344",
    "data-name": "Group 10344",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#dc492b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10336",
    "data-name": "Group 10336",
    transform: "translate(12.502 -1.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M18028.332,21277.848a2.877,2.877,0,0,1-2.871-2.875v-18.648a1.437,1.437,0,0,1,.418-1.012l4.3-4.3a1.417,1.417,0,0,1,1.02-.422h17.219a1.4,1.4,0,0,1,1.016.422l4.3,4.3a1.441,1.441,0,0,1,.422,1.012v18.648a2.882,2.882,0,0,1-2.875,2.875Zm0-2.875h22.961l-.012-17.211h-22.949Zm2.031-20.082h18.887l-1.43-1.437h-16.027Zm-.172,13.82v-7.684h3.848v3.848h11.539v-3.848h3.844v7.684Z",
    transform: "translate(-17991.256 -21230.217)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStock);
export default __webpack_public_path__ + "static/media/no-stock.11c2a13d565f6652c6a30d92f59846e7.svg";
export { ForwardRef as ReactComponent };